/**
 *@description 对Date的扩展，将 Date 转换为指定格式的String
 *月(MM)、日(dd)、小时(HH)、分(mm)、秒(ss)固定用两个占位符
 *年(yyyy)固定用4个占位符
 *例子：
 *(new Date()).format('yyyy-MM-dd hh:mm:ss') // 2018-07-31 20:09:04
 *(new Date()).format('yyyy-MM-dd') // 2018-07-31 20:08
 */
export function formatDate(date, fmt) {
  const re = /(y+)/
  if (re.test(fmt)) {
    const t = re.exec(fmt)[1]
    fmt = fmt.replace(t, (date.getFullYear() + '').substring(4 - t.length))
  }
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  }
  for (let k in o) {
    const regx = new RegExp('(' + k + ')')
    if (regx.test(fmt)) {
      const t = regx.exec(fmt)[1]
      fmt = fmt.replace(
        t,
        t.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

// 传yyyy-mm-dd格式，计算相差天数
export function calculateDaysDiff(date1, date2) {
  const [year1, month1, day1] = date1.split('-').map(Number)
  const [year2, month2, day2] = date2.split('-').map(Number)
  const diffTime = Math.abs(
    new Date(year2, month2, day2) - new Date(year1, month1, day1)
  )
  return diffTime / (1000 * 60 * 60 * 24)
}
